import axios from "../util/axios";

const login = (data) => {
  return axios.post("/login", data);
};

const register = (data) => {
  return axios.post("/register", data);
};

const googleRegister = (data) => {
  return axios.post(`/google/register/`, data);
};

const googleLogin = (data) => {
  return axios.post(`/google/login/`, data);
};

const microsoftLogin = (data) => {
  return axios.post(`/microsoft/login/`, data);
};

const microsoftRegister = (data) => {
  return axios.post(`/microsoft/register/`, data);
};

const sendPasswordResetRequest = (data) => {
  return axios.post(`/password_reset/request/`, data);
}

const resetPassword = (data) => {
  return axios.post(`/password_reset/confirm/`, data);
}

const AuthServices = {
  login,
  register,
  microsoftRegister,
  microsoftLogin,
  googleRegister,
  googleLogin,
  sendPasswordResetRequest,
  resetPassword,
};

export default AuthServices;
